"use client"; // Only needed if you're using the App Router (e.g., /app directory)

import { useEffect, useState } from "react";

export default function ShareButtons() {
  const [url, setUrl] = useState("");

  useEffect(() => {
    if (typeof window !== "undefined") {
      setUrl(window.location.href);
    }
  }, []);

  const shareViaEmail = () => {
    window.open(
      `mailto:?subject=Check this out&body=${encodeURIComponent(url)}`
    );
  };

  const shareOnFacebook = () => {
    window.open(
      `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`,
      "_blank"
    );
  };

  const shareOnTwitter = () => {
    window.open(
      `https://twitter.com/intent/tweet?url=${encodeURIComponent(
        url
      )}&text=Check this out!`,
      "_blank"
    );
  };

  return (
    <div className="flex space-x-4 justify-evenly mt-8">
      <button onClick={shareViaEmail} className="px-4 py-2 bg-gray-200 rounded">
        Share via Email
      </button>
      <button
        onClick={shareOnFacebook}
        className="px-4 py-2 bg-blue-600 text-white rounded"
      >
        Share on Facebook
      </button>
      <button
        onClick={shareOnTwitter}
        className="px-4 py-2 bg-blue-400 text-white rounded"
      >
        Share on Twitter
      </button>
    </div>
  );
}
